/* eslint-disable react/jsx-no-target-blank */
import {SidebarMenuTabsItem} from '../../../../../../_metronic/layout/components/sidebar/sidebar-menu/SidebarMenuTabsItem'
import {SidebarMenuItemWithSub} from '../../../../../../_metronic/layout/components/sidebar/sidebar-menu/SidebarMenuItemWithSub'
import {TabLimpiezaModel} from '../../../../models'
import {useLimpieza} from '../../../../hooks/useLimpieza'
const SidebarMenuLimpieza = () => {
  const {addTab, changeTab, menu} = useLimpieza()

  const addTabToContainer = (tab: TabLimpiezaModel) => {
    changeTab(addTab(tab))
  }
  return (
    <>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>HOSPITALITY</span>
        </div>
      </div>
      {menu &&
        menu.length > 0 &&
        menu.map((item) => {
          const existOption = item.opciones ? true : false
          const canList =
            existOption && item?.opciones.some((item: any) => item.opcion === 'ACCESO')
          const isShow = canList
          if (!isShow) return <></>
          return (
            <SidebarMenuItemWithSub
              key={item.id}
              to='/crafted/accounts'
              title={item.name}
              icon='/media/icons/duotune/communication/com006.svg'
              fontIcon='bi-person'
            >
              {item.arraySubItem.map((subItem: any) => {
                const existOption = subItem.opciones ? true : false
                const canList =
                  existOption && subItem?.opciones.some((item: any) => item.opcion === 'ACCESO')
                const isShow = canList
                if (!isShow) return <></>
                return (
                  <SidebarMenuTabsItem
                    key={subItem.id}
                    to='/lavanderia/clientes'
                    title={subItem.title}
                    hasBullet={true}
                    onClickHandler={() => addTabToContainer(subItem)}
                  />
                )
              })}
            </SidebarMenuItemWithSub>
          )
        })}
    </>
  )
}

export {SidebarMenuLimpieza}
